import { CustomException } from '@tencent/ppd-base-libs';
import {
  exchangePrize,
  qryActInfo,
  QryActInfoReq,
  SharePrizeInfo,
  SharePrizeInfoStatus,
} from '@tencent/wphk-act-base-cgi';
import { ActivityCouponState, qryAndFormatCouponList, QryType } from '@tencent/wphk-act-base-framework';
import { CouponState, ExchangeState, QryAndFormatCouponItem } from '@tencent/wphk-act-base-types';
import { C2CDialogCouponState, C2CIndexCouponState } from '../types';

const C2C_INVITE_CHANGE_NUM = 'c2c_invite_change_num';

/** 获取活动信息 */
export async function getC2CActInfo(data: QryActInfoReq) {
  return qryActInfo(data);
}

/** 获取缓存成功邀请人数 */
function getInviteChangeNum() {
  return Number(localStorage.getItem(C2C_INVITE_CHANGE_NUM) || '0');
}

/** 设置缓存成功邀请人数 */
export function setInviteChangeNum(value: number) {
  localStorage.setItem(C2C_INVITE_CHANGE_NUM, String(value));
}

/** 获取成功邀请人数是否变化 */
export function getSuccessInviteNum(value: number) {
  const cache = getInviteChangeNum();
  return value - cache;
}

/** 查券 */
export async function getC2CCouponList(prizeList: SharePrizeInfo[]): Promise<QryAndFormatCouponItem[]> {
  const qualIdList = Array.from(new Set(prizeList.map(ele => ele.prizeId)));
  /** 已过期 已领取 总库存无 今日库存无 未领取 */
  const couponList = await qryAndFormatCouponList({
    qryType: QryType.ByQualIdList,
    qryIdList: qualIdList,
    couponStateSort: [
      ActivityCouponState.used,
      ActivityCouponState.expired,
      ActivityCouponState.received,
      ActivityCouponState.totalLimit,
      ActivityCouponState.dayLimit,
      ActivityCouponState.notReceived,
    ],
  });
  return couponList;
}

/** 获取首页券状态 */
export function getC2CIndexCouponState(status: SharePrizeInfoStatus): C2CIndexCouponState {
  // 已兑换
  if ([SharePrizeInfoStatus.Exchanged].includes(status)) {
    return C2CIndexCouponState.exchanged;
  }
  // 可兑换
  if ([SharePrizeInfoStatus.Exchangeable].includes(status)) {
    return C2CIndexCouponState.exchangeable;
  }
  return C2CIndexCouponState.lock;
}

/** 获取弹窗券状态 */
export function getC2CDialogCouponState(
  coupon: QryAndFormatCouponItem,
  indexStatus: C2CIndexCouponState,
): C2CDialogCouponState {
  // 已兑换
  if (indexStatus === C2CIndexCouponState.exchanged) {
    if (coupon.couponState === CouponState.used) {
      return C2CDialogCouponState.used;
    }
    if (coupon.couponState === CouponState.expired) {
      return C2CDialogCouponState.expired;
    }
    if (coupon.couponState === CouponState.received) {
      return C2CDialogCouponState.received;
    }
    new CustomException(coupon, 'ErrorCouponState', '未知券状态1');
    return C2CDialogCouponState.unknown;
  }
  // 可兑换
  if (indexStatus === C2CIndexCouponState.exchangeable) {
    if (coupon.exchangeState === ExchangeState.totalLimit || coupon.exchangeState === ExchangeState.dayLimit) {
      return C2CDialogCouponState.limit;
    }
    if (coupon.couponState === CouponState.notReceived) {
      return C2CDialogCouponState.notReceived;
    }
    new CustomException(coupon, 'ErrorCouponState', '未知券状态2');
    return C2CDialogCouponState.unknown;
  }
  return C2CDialogCouponState.locked;
}

/** 兑换券 */
export async function exchangeCoupon(qualId: string, actListid: string, prizeNo: string) {
  try {
    await exchangePrize({ qualId, actListid, prizeNo });
    return true;
  } catch (error: any) {
    if (error.retcode === '3') {
      return false;
    }
    throw error;
  }
}
